window.vitaminImageComplete = function ($img, cb)
{
  if ($img[0].complete) cb();
  else
  {
    setTimeout(function ()
    {
      window.vitaminImageComplete($img, cb);
    }, 10);
  }
};


window.vitaminWaitForJquery = function (cb)
{
  if (window.jQuery) cb(window.jQuery);
  else
  {
    setTimeout(function ()
    {
      window.vitaminWaitForJquery(cb);
    }, 10);
  }
};

window.vitaminWaitForJquery(function ($)
{
  $(function ()
  {
    var adjustStickHeader = function ()
    {
      if ($(window).width() < 670) 
      {
        //$('body').removeClass('use-sticky-header');
        //$('#page-wrap').removeClass('stuck');
      }
      else
      {
        $('body').addClass('use-sticky-header');
        if ($(window).width() <= 1024) $('#page-wrap').removeClass('stuck');
        else if ($(window).scrollTop() >= 100) $('#page-wrap').addClass('stuck');
        else $('#page-wrap').removeClass('stuck');
      }
    };

    $(window).scroll(function ()
    {
      adjustStickHeader();
    });

    $(window).resize(function ()
    {
      adjustStickHeader();
    }).resize();
  });
});

window.vitaminUpdateMiniCart = function ()
{
  var total = $('#cart-summary .amount').html();
  var number = 0;
  $('#cart-summary input').each(function ()
  {
    number += Number($(this).val());
  });
  $('.mobile-mini-cart').html(number + ' / ' + total + ' <i class="icon-cart"></i>');
  $('#vitamin-super-header>div>.right>.cart').html('<div class="items">' + number + '</div><span class="divider">/</span><div class="total">' + total + '</div><div class="icon-cart"></div>');
};